import styled from 'styled-components'

var isMobile = window.innerWidth < 712
var swatch_size = isMobile ? 8 : 10

export const ColorKey = ({
  entries,
  children,
  centered = false,
  transparent = false,
}: {
  entries: {
    label: string
    color: string
    type?: 'line' | 'rect' | 'circle'
    opacity?: number
  }[]
  children?: React.ReactNode
  centered?: boolean
  transparent?: boolean
}) => {
  return (
    <ColorKeyRoot
      className='colorkey'
      style={{
        marginLeft: centered ? 'auto' : undefined,
        marginRight: centered ? 'auto' : undefined,
        justifyContent: centered ? 'center' : 'flex-start',
        backgroundColor: transparent ? 'transparent' : 'var(--site-background)',
      }}
    >
      <Label style={{ opacity: entries[0].opacity || 0.8 }}>
        {entries[0].label}
      </Label>
      {entries.map((entry, i) => {
        var opacity = entry.opacity ? entry.opacity : 1
        return (
          <Entry
          key={"colorkey_"+i}
            style={{
              opacity: opacity,
            }}
          >
            <CircleSwatch
              style={{
                backgroundColor: entry.color,
                marginLeft: i === 0 ? '5px' : '0',
              }}
            />
          </Entry>
        )
      })}{' '}
      <Label style={{ opacity: entries[entries.length - 1].opacity || 1 }}>
        {entries[entries.length - 1].label}
      </Label>
      {children && (
        <EntryExtra>
          {children && (
            <>
              <PatternSVG
                width={swatch_size + 'px'}
                height={swatch_size + 'px'}
              >
                {' '}
                <pattern
                  id='diagonalHatch'
                  patternUnits='userSpaceOnUse'
                  width='3'
                  height='6'
                  patternTransform='rotate(-45 2 2)'
                >
                  <path
                    d='M -1,2 l 6,0'
                    stroke='var(--hatch-color)'
                    strokeWidth='0.5'
                  />
                </pattern>
                <rect
                  width={swatch_size + 2}
                  height={swatch_size + 2}
                  fill='url(#diagonalHatch)'
                />
              </PatternSVG>

              <Label style={{ marginLeft: '5px' }}>{children}</Label>
            </>
          )}
        </EntryExtra>
      )}
    </ColorKeyRoot>
  )
}
const PatternSVG = styled.svg`
  border: 1.5px solid var(--text-color);
  margin-left: 20px;
  flex: 0 0 ${swatch_size}px;
  @media screen and (max-width: 712px) {
    margin-left: 0px;
  }
`
const CircleSwatch = styled.div`
  width: ${swatch_size}px;
  height: ${swatch_size}px;
  border-radius: 6px;
  margin-right: 8px;
  margin-top: 3px;
`

const ColorKeyRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: flex-start;
  line-height: 1em;
  background-color: var(--site-background);
  padding: 4px;
  padding-left: 0;
`

const Label = styled.div`
  font-size: 14px;
  letter-spacing: 0.2px;

  @media screen and (max-width: 712px) {
    font-size: 12px;
  }
`

const Entry = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  min-height: 16px;

  justify-content: center;
  @media screen and (max-width: 712px) {
    font-size: 12px;
  }
`

const EntryExtra = styled(Entry)`
  justify-content: flex-start;
  @media screen and (max-width: 712px) {
    margin-top: 10px;
    flex: 0 0 100%;
  }
`
